module.exports = __webpack_public_path__ + "a04dba8261e468f494f9e75df619adc0.png";